import { motion } from "framer-motion";
import { UserCircle, Search, CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";
export const QuickStartGuide = () => {
  const {
    t
  } = useTranslation("landing");
  const steps = [{
    icon: <UserCircle className="h-12 w-12 text-primary" />,
    title: t("quickStartGuide.step1Title"),
    description: t("quickStartGuide.step1Description")
  }, {
    icon: <Search className="h-12 w-12 text-primary" />,
    title: t("quickStartGuide.step2Title"),
    description: t("quickStartGuide.step2Description")
  }, {
    icon: <CheckCircle2 className="h-12 w-12 text-primary" />,
    title: t("quickStartGuide.step3Title"),
    description: t("quickStartGuide.step3Description")
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-12 px-4 bg-white">
      <div className="container mx-auto max-w-6xl">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }}>
          <h2 className="text-2xl md:text-3xl font-bold mb-3">
            {t("quickStartGuide.title")}
          </h2>
          
        </motion.div>

        <motion.div className="grid md:grid-cols-3 gap-6 relative" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-50px"
      }}>
          {/* Connection lines */}
          <div className="absolute top-1/4 left-1/3 right-1/3 h-1 bg-gradient-to-r from-primary/80 to-primary/30 hidden md:block"></div>
          <div className="absolute top-1/4 right-1/3 w-1 h-12 bg-gradient-to-b from-primary/30 to-transparent hidden md:block"></div>
          
          {steps.map((step, index) => <motion.div key={index} className="flex flex-col items-center text-center" variants={itemVariants} whileHover={{
          y: -8
        }} transition={{
          type: "spring",
          stiffness: 300
        }}>
              <div className="relative">
                <div className="absolute inset-0 bg-primary/10 rounded-full scale-150 blur-lg"></div>
                <div className="relative bg-white border-2 border-primary/30 rounded-full p-4 mb-4 shadow-lg">
                  {step.icon}
                </div>
                <div className="absolute -top-2 -right-2 flex items-center justify-center w-6 h-6 rounded-full bg-primary text-white font-bold text-xs">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-lg font-bold mb-2">{step.title}</h3>
              <p className="text-gray-600 text-sm">{step.description}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
};